<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.invoiceNum') }}</div>
                <input v-model="searchParams.invoiceNum" type="text" />
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.recode') }}</div>
                <input v-model="searchParams.recode" type="text" />
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.fromDate') }}</div>
                <CalendarSelect
                  v-model="searchParams.dateFrom"
                  mode="date"
                  @input="onChangeDateFrom"
                />
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.toDate') }}</div>
                <CalendarSelect
                  v-model="searchParams.dateTo"
                  mode="date"
                  @input="onChangeDateTo"
                />
              </div>
            </div>
            <!-- <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.groupService') }}</div>
                <select-with-search-table
                  style="width: 100%"
                  index-field="id"
                  :search-fields="['code', 'desc']"
                  :selected-index-field-value="searchParams.groupService"
                  :rows="groupServiceOptions"
                  :columns="groupServiceOptionsCols"
                  :value="searchParams.bookingGroup"
                  :dropdown-width="400"
                  :is-remove-btn="true"
                  @selectionChanged="onSelectBookingGroup"
                >
                  <template v-slot:value="{ selectedValue: selectedData }">
                    <div>
                      <span v-if="selectedData?.code && selectedData?.desc">
                        {{ selectedData.code }} -
                        {{ selectedData.desc }}
                      </span>
                    </div>
                  </template>
                </select-with-search-table>
              </div>
            </div> -->
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Hình thức hoàn</div>
                <el-select
                  v-model="searchParams.refundType"
                  clearable
                  placeholder=""
                >
                  <el-option
                    v-for="item in refundTypeOptions"
                    :key="item.id"
                    :label="item.value"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Người thao tác</div>
                <el-select
                  v-model="searchParams.createUserId"
                  clearable
                  placeholder=""
                >
                  <el-option
                    v-for="item in cashierOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">{{ $t('field.hotel') }}</div>
                <el-select
                  v-model="searchParams.hotelIdList"
                  multiple
                  collapse-tags
                  filterable
                  clearable
                  placeholder=""
                >
                  <el-option
                    v-for="item in hotelOptions"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <!-- <div class="laundry-report__wrapper"> -->
    <div class="content-box report-grid-container">
      <div class="section-box outline">
        <div class="das-form-container" style="flex: 1">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title"> Báo cáo hoàn tiền</span>
            </div>
            <div class="flex" style="gap: 10px">
              <InfoBtn @click="noteDialogVisible = true" />
              <el-dropdown trigger="click" @command="onClickDropdownItem">
                <das-button
                  color="primary"
                  size="medium"
                  :rounded="false"
                  outline
                  icon
                >
                  <i class="el-icon-download"></i>
                </das-button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">
                    {{ $t('button.exportPdf') }}
                  </el-dropdown-item>
                  <el-dropdown-item command="excel">
                    {{ $t('button.exportExcel') }}
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <hr />
          <!-- <div class="das-form-title-container mt-20">
              <div class="das-form-title">
                <span class="sub-title"> Giặt là </span>
              </div>
            </div> -->

          <div v-loading="loading" class="collapse-grid__list">
            <p
              v-if="laundryDataList.length == 0"
              style="text-align: center; margin-top: 100px"
            >
              Không có dữ liệu
            </p>
            <el-collapse v-model="collapseNameList">
              <div
                v-for="laundryData in laundryDataList"
                :key="laundryData.hotel_id"
                class="collapse-grid__item"
              >
                <el-collapse-item :name="laundryData.hotel_id">
                  <template slot="title">
                    <span class="collapse-grid__item-header">
                      {{ 'Khách sạn:' }} {{ laundryData.hotel_nm }}
                    </span>
                  </template>
                  <div class="grid-scroll" style="height: 400px">
                    <GridVx
                      ref="agGrid"
                      :columns="columns"
                      :rows="laundryData?.detail"
                      :is-row-selectable="isRowSelectable"
                      class="agGrid collapse-grid__agGrid"
                      :default-col-def="defaultColDef"
                      dom-layout="scroll"
                      :auto-size-cell="true"
                      :context="context"
                      :full-width-cell-renderer="fullWidthCellRenderer"
                      :embed-full-width-rows="true"
                    />
                    <!-- :pinned-bottom-row-data="pinnedBottomRowData" -->
                  </div>
                </el-collapse-item>

                <div class="collapse-grid__item-footer">
                  {{ 'Tổng' }}: {{ $displayCurrency(laundryData.total_money) }}
                </div>
              </div>
            </el-collapse>
          </div>

          <hr style="margin-top: 14px" />
          <div class="total-price">
            Tổng: {{ $displayCurrency(totalAmount) }}
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="content-box">
      <LaundryPieChartReport />
    </div>
    <div class="content-box">
      <div class="section-box outline">
        <search-comp>
          <div class="das-form-container">
            <div class="das-form-group">
              <div class="das-form-row">
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">{{ $t('field.fromDate') }}</div>
                    <CalendarSelect mode="date" />
                  </div>
                </div>
                <div class="das-form-col col-3">
                  <div class="das-form-input">
                    <div class="label">{{ $t('field.toDate') }}</div>
                    <CalendarSelect mode="date" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </search-comp>
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title"> Biểu đồ Histogram </span>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- </div> -->

    <el-dialog
      :title="$t('dialog.titleNote')"
      :visible.sync="noteDialogVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="note-container">
            <h3 class="note-title">Bảng dữ liệu</h3>
            <ul>
              <li>Khách sạn: Hiển thị tên khách sạn</li>
              <li>Mã hóa đơn: Hiển thị mã hóa đơn được thực hiện hoàn tiền</li>
              <li>Recode: Hiển thị mã đặt phòng có hóa đơn hoàn tiền</li>
              <li>
                Số tiền hoàn: Hiển thị số tiền hoàn lại của hóa đơn trong giao
                dịch hoàn tiền
              </li>
              <li>
                Lý do hoàn: Hiển thị Ghi chú khi hoàn tiền của giao dịch hoàn
                tiền
              </li>
              <li>
                Thời gian thao tác: Hiển thị thời gian thực hiện giao dịch hoàn
                tiền theo fomat DD/MM/YYYY HH:MM
              </li>
              <li>
                Hình thức hoàn: Hiển thị loại phương thức thực hiện hoàn tiền
              </li>
              <li>
                Người thao tác: Hiển thị tên nhân viên thực hiện hoàn tiền
              </li>
              <li>
                Tổng cộng: tổng tiền tất cả các giao dịch hoàn tiền trong ngày
                được tìm kiếm tại khách sạn
              </li>
              <li>
                Tổng: Hiển thị tổng tiền tất cá các giao dịch hoàn tiền trong
                tất cá các khách sạn trong thời gian tìm kiếm
              </li>
              <li>Lấy giữ liệu khi nhân viên thực hiện giao dịch hoàn tiền</li>
            </ul>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="noteDialogVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import DasButton from '@/components/ui/DasButton.vue'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import FullWidthCellTransaction from './components/FullWidthCellTransaction.vue'
import InfoBtn from './components/InfoBtn.vue'
import { getAllHotel } from '@/api/hotel.js'
import { getUserApi } from '@/api/userConfig/user'

import { getRefundList } from '@/api/report_service/refundReport'
import { CellRenderUnderscoreText } from '@/utils/cellRenders'
import moment from 'moment'

const getDefaultSearchParams = () => ({
  dateFrom: moment().format('YYYY-MM-DD'),
  dateTo: moment().format('YYYY-MM-DD'),
  hotelIdList: [],
  createUserId: null,
  refundType: null,
  invoiceNum: null,
  recode: null,
  code: null
})

export default {
  components: {
    DasButton,
    CalendarSelect,
    CellRenderUnderscoreText,
    // eslint-disable-next-line vue/no-unused-components
    InfoBtn,
    // eslint-disable-next-line vue/no-unused-components
    FullWidthCellTransaction
  },
  data() {
    return {
      context: null,
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        wrapText: true,
        autoHeight: true
      },
      noteDialogVisible: false,
      searchParams: getDefaultSearchParams(),
      hotelOptions: [],
      groupServiceOptions: [],
      receptionistOptions: [],
      cashierOptions: [],
      refundTypeOptions: [
        {
          id: 1,
          value: 'Chuyển khoản'
        },
        {
          id: 2,
          value: 'Thẻ'
        },
        {
          id: 3,
          value: 'Công nợ'
        },
        {
          id: 4,
          value: 'Tiền mặt'
        }
      ],
      columns: [
        {
          headerName: this.$t('grid.column.invoiceNum'),
          field: 'invoice_num',
          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 110,
          maxWidth: 140
        },
        {
          headerName: this.$t('grid.column.recode'),
          field: 'recode',
          cellRenderer: 'CellRenderUnderscoreText',
          // cellClass: "grid-cell-centered",
          // width: 100,
          // flex: 1,
          sortable: false,
          minWidth: 200
        },
        {
          headerName: this.$t('grid.column.refundMoney'),
          field: 'refund',
          cellRenderer: params => this.$displayCurrency(params.value),
          tooltipValueGetter: params => this.$displayCurrency(params.value),
          // cellClass: "grid-cell-centered",
          // width: 100,
          minWidth: 100,

          sortable: false
        },
        {
          headerName: this.$t('grid.column.refundReason'),
          field: 'note',
          tooltipField: 'note',
          // cellClass: "grid-cell-centered",
          // width: 100,
          // flex: 1,
          sortable: false,
          minWidth: 250
        },
        {
          headerName: this.$t('grid.column.timeOperation'),
          field: 'create_date',
          // cellClass: "grid-cell-centered",
          // width: 100,
          // flex: 1,
          sortable: false,
          minWidth: 200
        },
        {
          headerName: this.$t('grid.column.refundType'),
          field: 'refund_type',
          // cellClass: "grid-cell-centered",
          // width: 100,
          // flex: 1,
          sortable: false,
          minWidth: 100,
          maxWidth: 150
        },
        {
          headerName: this.$t('grid.column.applyPerson'),
          field: 'full_name',
          // cellClass: "grid-cell-centered",
          // width: 100,
          // flex: 1,
          sortable: false,
          minWidth: 150,
          flex: 1
        }
      ],
      rows: [],
      pinnedBottomRowData: [],
      isRowSelectable: node => !node.data.isFullWidthRow,
      laundryDataList: [
        {
          id: 1,
          hotel_name: 'Test'
        },
        {
          id: 2,
          hotel_name: 'ABC'
        }
      ],
      collapseNameList: [],
      totalAmount: 0,
      selectedRecode: null,

      loading: false
    }
  },
  beforeMount() {
    // GRID
    this.fullWidthCellRenderer = 'FullWidthCellTransaction'
    this.context = {
      componentParent: this
    }
  },
  mounted() {
    this.getHotelOptions()
    this.getCashierOptions()
    this.attachData()
  },
  methods: {
    checkValidDateRange(dateFrom, dateTo) {
      if (dateFrom && dateTo && dateFrom > dateTo) {
        this.$message({
          type: 'error',
          message: this.$t('errorMsg.fromDateMustEarlierThanToDate')
        })
        return false
      }
      return true
    },

    onChangeDateFrom(date) {
      this.searchParams.dateFrom = date
      if (!this.checkValidDateRange(date, this.searchParams.dateTo)) {
        setTimeout(() => {
          this.searchParams.dateTo = null
        })
      }
    },

    onChangeDateTo(date) {
      this.searchParams.dateTo = date
      if (!this.checkValidDateRange(this.searchParams.dateFrom, date)) {
        setTimeout(() => {
          this.searchParams.dateTo = null
        })
      }
    },

    // SELECT OPTIONS
    getHotelOptions() {
      getAllHotel().then(res => {
        this.hotelOptions = res.data
      })
    },

    getCashierOptions() {
      getUserApi({
        department: 'CASHIER'
      }).then(res => {
        this.cashierOptions = res.data.map(person => ({
          label: person.account.full_name,
          value: person.account.id
        }))
      })
    },

    onSearch() {
      this.attachData()
    },
    onReset() {
      this.searchParams = getDefaultSearchParams()
      this.attachData()
    },
    onClickDropdownItem(cmd) {
      this.$message('click on item ' + cmd)
    },

    attachData() {
      this.loading = true
      if (this.searchParams.recode) {
        this.searchParams.dateFrom = ''
        this.searchParams.dateTo = ''
      }
      getRefundList(this.searchParams)
        .then(res => {
          this.laundryDataList = res?.map?.data
          this.totalAmount = res?.map?.total
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onClickFolio(params) {
      console.log('clicker clicker', params)
      this.selectedRecode = params.data.recode
      this.$router.push({
        path: '/reservation/search_reservation'
        // recode:
      })
    },
    async fnStoreRouteData({ to, from }) {
      const params = {
        ...to.params,
        recode: this.selectedRecode
      }
      const routeData = {
        ...to,
        from,
        params
      }
      this.$store.dispatch('app/setRouteData', routeData)
      this.selectedRecode = null
    }
  },
  async beforeRouteLeave(to, from, next) {
    if (to.path === '/reservation/search_reservation') {
      await this.fnStoreRouteData({ to, from })
    }
    next()
  }
}
</script>

<style></style>

<style lang="scss" scoped>
.agGrid {
  .ag-full-width-row {
    background-color: #fff !important;
  }
}

.total-price {
  font-weight: 600;
  text-align: right;
}

// .col-span-2 {
//   grid-column: span 2 / span 2;
// }

// .laundry-report__wrapper {
//   display: grid;
//   grid-template-columns: repeat(1, minmax(0, 1fr));
//   gap: 10px;
//   // flex-wrap: wrap;
//   // flex-direction: column;

//   .laundry-report__table-wrapper {
//     grid-column: 1 / span 1;
//   }

//   .content-box {
//     min-height: 600px;
//   }
// }

// @media only screen and (min-width: 1280px) {
//   .laundry-report__wrapper {
//     grid-template-columns: repeat(2, (minmax(0, 1fr)));

//     .laundry-report__table-wrapper {
//       grid-column: 1 / span 2;
//     }
//   }
// }
</style>

<style lang="scss">
.report-grid-container {
  --cell-border-color: rgba(189, 195, 199, 0.5);
  --ag-header-bg: #5f8b76;

  height: 100%;

  .collapse-grid__list {
    display: flex;
    flex-direction: column;
    gap: 20px;
    flex: 1;
    // overflow-y: auto;

    .el-collapse {
      border: 0 !important;
    }
  }

  .collapse-grid__item {
    .el-collapse-item__header {
      background-color: #357456;
      color: #fff !important;
      border-bottom: 1px solid var(--cell-border-color);
    }

    .el-collapse-item__content {
      padding-bottom: 0;
    }

    &-header {
      font-weight: 600;
      flex: 1;
      font-size: 14px;
      padding: 0 12px;
    }

    &-footer {
      height: 34px;
      line-height: 34px;
      padding: 0 12px;
      background-color: #e7f6e5 !important;
      border-bottom: 1px solid var(--cell-border);
      margin-bottom: 2px;
      font-weight: 500;
      font-size: 14px;
    }

    .grid-scroll {
      // height: 400px;
      // max-height: 400px;
    }

    .agGrid.collapse-grid__agGrid {
      .ag-header-viewport {
        background-color: var(--ag-header-bg) !important;
      }

      .header-row,
      .header-row:hover {
        background-color: var(--ag-header-bg) !important;
        color: white;
        font-weight: bold;
      }

      .ag-header-row-column {
        background-color: var(--ag-header-bg) !important;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.content-container .content-box .section-box.outline {
  height: auto !important;
  min-height: 100%;
}
</style>
